import { withGuard } from 'ui-components/components/with-guard';
import { SimpleModal as SimpleModalWithoutGuard } from './simple-modal';

const SimpleModal = withGuard(SimpleModalWithoutGuard);

export { SimpleModal };
